import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { updateOrganization as updateOrganizationAction } from 'data/organizations/actions'
import { goToOrganizationUpgrade as goToOrganizationUpgradeAction } from 'data/ui/actions'
import { isFree } from 'data/organizations/selectors'

import Layout from './Layout'
import useOrganizationField from '../hooks/useOrganizationField'

export default function SettingsOrganizationInformationsSharing() {
  const organizationMembersCanInvite = useOrganizationField('membersCanInvite')
  const roleForPublicSharing = useOrganizationField(
    'requiredRoleForPublicSharing'
  )
  const organizationIsFree = useSelector(isFree)

  const dispatch = useDispatch()
  const updateOrganization = React.useCallback(
    params => dispatch(updateOrganizationAction(params)),
    [dispatch]
  )
  const goToOrganizationUpgrade = React.useCallback(
    ({ incentiveId }) => {
      dispatch(goToOrganizationUpgradeAction({ incentiveId }))
    },
    [dispatch]
  )

  return (
    <Layout
      organizationIsFree={organizationIsFree}
      organizationMembersCanInvite={organizationMembersCanInvite}
      organizationRequiredRoleForPublicSharing={roleForPublicSharing}
      updateOrganization={updateOrganization}
      goToOrganizationUpgrade={goToOrganizationUpgrade}
    />
  )
}
